import clsx from 'clsx';
import { mePanelStyle } from '../profile/profile-panel/components/me-panel/me-panel.style';

interface MessageItemProps {
    posttime: string,
    content: string
}

export const MessageItem = ({ posttime, content }: MessageItemProps) => {
	

	const checkContent = (content: string):boolean => {
		const fontText = '<font';
		return content.includes(fontText);
	}


	return (
		<div className="message__item">
			{checkContent(content) ? 
				<p className={clsx('message__content', mePanelStyle.messageText)} dangerouslySetInnerHTML={{ __html: content }}></p>:
				<p className={clsx('message__content', mePanelStyle.messageText)}>{content}</p>}	
			<p className={clsx('message__date', mePanelStyle.messageText)}>{posttime}</p>
		</div>
	)
}